module.exports = __webpack_public_path__ + "static/media/plus-branco.3d3eb44a.webp";